exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-e45522b2] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.expert-blurred-name[data-v-e45522b2] {\n}\n\n\n\n", ""]);

// exports
